module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_1_3_2-21599584e3a1e2e0cf1f891fbfcd15b2.webp";